import {environment} from '../../environments/environment';

export const EXTENT = [1.3902440415778201, 49.76471697185164, 7.874942661657129, 51.447825663926324];

export const LAYERS = [
  {
    id: 'cropmap_2018',
    name: 'Cropmap 2018',
    year: '2018',
    source: {
      type: "WMS",
      url: "/proxy/maps/geoserver/wms",
      style: "default",
      params: {
        LAYERS: "VITO:Belgium_CropMap_June2018_cog",
        TILED: true,
      }
    },
    visible: false
  }, {
    id: 'cropmap_2019',
    name: 'Cropmap 2019',
    year: '2019',
    source: {
      type: "WMS",
      url: "/proxy/maps/geoserver/wms",
      style: "default",
      params: {
        LAYERS: "VITO:Belgium_CropMap_June2019",
        TILED: true,
      }
    },
    visible: false
  }, {
    id: 'cropmap_2020',
    name: 'Cropmap 2020',
    year: '2020',
    source: {
      type: "WMS",
      url: "/proxy/maps/geoserver/wms",
      style: "default",
      params: {
        LAYERS: "VITO:Belgium_CropMap_August2020_cog",
        TILED: true,
      }
    },
    visible: false
  }

];

export const bgLayer = {
  id: 'MapBox',
  visible: true,
  zIndex: -1,
  source: {
    type: 'Mapbox',
    style: 'satellite-v9',
    token: 'pk.eyJ1IjoiZ2VvZGF0YWRldiIsImEiOiJjajdzcjd4djMzdzFnMzN1dzNodGhkOXUwIn0.ThyY4gnMBQvT0dX1FSMt4Q'
  }
};

export const overlay = {
  id: 'overlay',
  visible: true,
  zIndex: -1,
  source: {
    type: 'Mapbox',
    userId: 'geodatadev',
    style: 'cj8k6jvhw4pli2rnrlmjw5yy6',
    token: 'pk.eyJ1IjoiZ2VvZGF0YWRldiIsImEiOiJjajd6ejNnZWY2YXphMnFwZmh4Y2h6N2c4In0.qQOAcXvx6GxJgEo3UYYVAA'
  },
};

export const templateLayer = {
  id: 'id',
  type: 'type',
  source: {},
  visible: false,
  zIndex: 10,
  style: 'light-v8'
};



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Angular_wig_cropmap_master/src/app/config/layers.config.ts